// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__Iiery","playLink":"Menu_playLink__045hA"};